import boldplayService from '../services/boldplay.service'

const handlers = {
  boldplay: {
    session: {
      set: 'boldplay_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.boldplay = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.boldplay = (state => state.boldplay);
}

const initActions = function(actions) {
  actions[handlers.boldplay.session.set] = ({ commit }, session) => commit(handlers.boldplay.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.boldplay.session.set] = (state, session) => state.boldplay.session = session;
}

const initAppState = function(appState, store) {
  appState.boldplay = {
    session: {
      get: () => store.getters.boldplay.session,
      open: async (gameId, language, isMobile) => {
        let session = await boldplayService.openSession(gameId, language, isMobile);
        store.dispatch(handlers.boldplay.session.set, session);
      },
      openDemo: async (gameId, language, isMobile) => {
        let session = await boldplayService.openDemoSession(gameId, language, isMobile);
        store.dispatch(handlers.boldplay.session.set, session);
      },
      close: async () => {
        if (store.getters.boldplay.session) {
          await boldplayService.closeSession();
        }
        store.dispatch(handlers.boldplay.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/boldplay.js